import { useId } from "react";
import { cn } from "@/lib/utils";

export const SALON_FALLBACK_IMAGE_SRC =
  "/service-image.svg?v=2";

export const SalonFallbackIcon = ({ className, ...props }) => {
  return (
    <img
      src={SALON_FALLBACK_IMAGE_SRC}
      alt="Salon placeholder"
      className={cn("h-full w-full object-cover", className)}
      {...props}
    />
  );
};

export const CandidateCardsIcon = (props) => {
  return (
    <svg
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      name="CandidateCardsIcon"
      fill="none"
      data-left-icon="true"
      {...props}
    >
      <path
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M18.9569 21.0043H5.04307C3.93761 21.0043 3.04224 20.1089 3.04224 19.0035V7.99888C3.04224 6.89342 3.93761 5.99805 5.04307 5.99805H18.9569C20.0623 5.99805 20.9577 6.89342 20.9577 7.99888V19.0035C20.9577 20.1089 20.0613 21.0043 18.9569 21.0043Z"
        clipRule="evenodd"
        vectorEffect="non-scaling-stroke"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M11.9999 8.99805C13.3815 8.99805 14.501 10.1175 14.501 11.4991C14.501 12.8807 13.3815 14.0001 11.9999 14.0001C10.6184 14.0001 9.4989 12.8807 9.4989 11.4991C9.4989 10.1175 10.6184 8.99805 11.9999 8.99805"
        vectorEffect="non-scaling-stroke"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M16.5019 18.0026C16.3708 17.6734 16.1677 17.3773 15.9076 17.1362V17.1362C15.4684 16.728 14.8932 16.502 14.2929 16.502C13.2925 16.502 10.7074 16.502 9.70703 16.502C9.10678 16.502 8.53254 16.729 8.09236 17.1362V17.1362C7.83225 17.3773 7.62916 17.6734 7.49811 18.0026"
        vectorEffect="non-scaling-stroke"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M4.77893 5.99734V4.99693C4.77893 3.89147 5.6743 2.99609 6.77976 2.99609H17.2191C18.3246 2.99609 19.2199 3.89147 19.2199 4.99693V5.99734"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};

export const ProgressRingIcon = ({
  value = 0,
  total = 1,
  className,
  trackColor = "rgba(17,17,17,0.32)",
  progressColor = "white",
  radius = 6,
  strokeWidth = 1.6,
  ...props
}) => {
  const circumference = 2 * Math.PI * radius;
  const progress = total > 0 ? value / total : 0;
  const offset = circumference * (1 - progress);

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      className={cn("size-[14px] -rotate-90", className)}
      {...props}
    >
      <circle
        cx="8"
        cy="8"
        r={radius}
        fill="none"
        stroke={trackColor}
        strokeWidth={strokeWidth}
      />
      <circle
        cx="8"
        cy="8"
        r={radius}
        fill="none"
        stroke={progressColor}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const ZoblissLogo = (props) => {
  return (
    <svg
      width={338}
      height={62}
      viewBox="0 0 338 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M123.775 60.89H78.7248V55.6032L114.875 7.32803H80.6231V0.796082H123.856V6.22576L88.0124 54.358H123.775V60.89Z"
        fill="#11110D"
      />
      <path
        d="M149.365 61.6861C145.211 61.6861 141.537 60.7165 138.342 58.7671C135.143 56.8228 132.632 54.1284 130.81 50.6838C128.998 47.2443 128.095 43.315 128.095 38.9059C128.095 34.6091 128.998 30.7767 130.81 27.4138C132.632 24.0559 135.143 21.4023 138.342 19.453C141.537 17.5087 145.211 16.534 149.365 16.534C153.514 16.534 157.203 17.5087 160.428 19.453C163.664 21.4023 166.205 24.0559 168.042 27.4138C169.879 30.7767 170.798 34.6091 170.798 38.9059C170.798 43.2741 169.889 47.1831 168.083 50.6226C166.271 54.0519 163.745 56.7565 160.51 58.7263C157.285 60.7012 153.57 61.6861 149.365 61.6861ZM149.365 55.7665C152.151 55.7665 154.652 55.0317 156.856 53.562C159.061 52.0923 160.801 50.0868 162.082 47.5403C163.373 44.999 164.021 42.1209 164.021 38.9059C164.021 35.8185 163.388 33.0272 162.123 30.5369C160.867 28.0363 159.142 26.0615 156.938 24.6173C154.733 23.1782 152.207 22.4536 149.365 22.4536C146.589 22.4536 144.088 23.1629 141.874 24.5765C139.669 25.9951 137.934 27.9547 136.668 30.4552C135.413 32.9455 134.79 35.7624 134.79 38.9059C134.79 42.1719 135.428 45.0806 136.709 47.622C138 50.1684 139.751 52.1637 141.955 53.6028C144.16 55.047 146.63 55.7665 149.365 55.7665Z"
        fill="#11110D"
      />
      <path
        d="M199.211 61.6861C196.215 61.6861 193.643 61.1349 191.495 60.0327C189.341 58.9304 187.167 56.9606 184.963 54.1131V60.89H178.268V0.796082H184.963V24.107C187.218 21.1676 189.438 19.1774 191.617 18.1262C193.791 17.0647 196.322 16.534 199.211 16.534C203.155 16.534 206.569 17.4934 209.458 19.4121C212.341 21.3309 214.586 23.9845 216.194 27.3729C217.796 30.7614 218.602 34.6908 218.602 39.1508C218.602 43.5599 217.796 47.4587 216.194 50.8471C214.586 54.2356 212.341 56.8892 209.458 58.8079C206.569 60.7267 203.155 61.6861 199.211 61.6861ZM198.578 55.7665C201.313 55.7665 203.671 55.0316 205.661 53.562C207.661 52.0923 209.197 50.1123 210.274 47.622C211.361 45.1215 211.907 42.2943 211.907 39.1508C211.907 35.9563 211.361 33.1088 210.274 30.6185C209.197 28.118 207.661 26.1278 205.661 24.6581C203.671 23.1884 201.313 22.4536 198.578 22.4536C195.909 22.4536 193.521 23.1782 191.413 24.6173C189.316 26.0614 187.678 28.0363 186.494 30.5368C185.31 33.0271 184.718 35.9002 184.718 39.1508C184.718 42.3505 185.31 45.2031 186.494 47.7036C187.678 50.1939 189.316 52.1637 191.413 53.6028C193.521 55.047 195.909 55.7665 198.578 55.7665Z"
        fill="#11110D"
      />
      <path
        d="M239.926 60.89H236.232C234.078 60.89 232.231 60.594 230.679 59.9918C229.128 59.3795 227.944 58.2772 227.128 56.685C226.311 55.0827 225.903 52.8373 225.903 49.949V0.796082H232.598V48.9079C232.598 50.2296 232.685 51.337 232.863 52.2352C233.052 53.1231 233.517 53.8018 234.252 54.2764C234.986 54.7561 236.17 54.9908 237.803 54.9908H239.926V60.89Z"
        fill="#11110D"
      />
      <path
        d="M249.221 9.83874C247.802 9.83874 246.593 9.35905 245.587 8.38947C244.592 7.42499 244.097 6.25638 244.097 4.87855C244.097 3.52113 244.592 2.36783 245.587 1.42886C246.593 0.479689 247.802 0 249.221 0C250.634 0 251.839 0.479689 252.834 1.42886C253.839 2.36783 254.344 3.52113 254.344 4.87855C254.344 6.25638 253.839 7.42499 252.834 8.38947C251.839 9.35905 250.634 9.83874 249.221 9.83874ZM252.528 60.89H245.832V17.3301H252.528V60.89Z"
        fill="#11110D"
      />
      <path
        d="M279.236 61.6861C273.653 61.6861 269.142 60.3593 265.702 57.7057C262.273 55.0521 260.191 51.4391 259.456 46.8667H266.458C267.039 49.4948 268.356 51.6381 270.397 53.2966C272.449 54.9449 275.419 55.7665 279.297 55.7665C282.247 55.7665 284.65 55.2052 286.503 54.0723C288.365 52.9445 289.299 51.2758 289.299 49.0713C289.299 47.2341 288.717 45.8206 287.564 44.8255C286.421 43.8202 284.915 43.0598 283.053 42.5393C281.185 42.0086 279.174 41.534 277.011 41.1104C275.133 40.743 273.26 40.3297 271.397 39.8653C269.53 39.3907 267.835 38.7324 266.315 37.8853C264.789 37.0433 263.564 35.9155 262.641 34.4968C261.727 33.0833 261.273 31.2717 261.273 29.0672C261.273 26.3319 261.967 24.0355 263.355 22.1678C264.743 20.3052 266.641 18.9018 269.05 17.9629C271.469 17.0137 274.153 16.534 277.092 16.534C281.828 16.534 285.768 17.7587 288.911 20.2082C292.065 22.6475 294.014 26.0461 294.749 30.4144H288.523C287.84 27.6281 286.487 25.6073 284.461 24.3519C282.446 23.0864 279.991 22.4536 277.092 22.4536C274.204 22.4536 271.959 22.9945 270.356 24.0661C268.764 25.1429 267.968 26.6279 267.968 28.516C267.968 30.0419 268.504 31.2411 269.581 32.1086C270.652 32.9659 272.056 33.6191 273.786 34.0682C275.526 34.5173 277.388 34.9561 279.379 35.3746C281.323 35.742 283.277 36.1809 285.237 36.681C287.207 37.1709 289.013 37.8649 290.646 38.763C292.279 39.651 293.575 40.8553 294.545 42.376C295.525 43.9018 296.015 45.8971 296.015 48.3568C296.015 52.3576 294.55 55.5828 291.626 58.0323C288.712 60.4715 284.584 61.6861 279.236 61.6861Z"
        fill="#11110D"
      />
      <path
        d="M321.052 61.6861C315.469 61.6861 310.958 60.3593 307.519 57.7057C304.089 55.0521 302.007 51.4391 301.273 46.8667H308.274C308.856 49.4948 310.172 51.6381 312.214 53.2966C314.265 54.9449 317.235 55.7665 321.113 55.7665C324.063 55.7665 326.467 55.2052 328.319 54.0723C330.182 52.9445 331.115 51.2758 331.115 49.0713C331.115 47.2341 330.534 45.8206 329.38 44.8255C328.237 43.8202 326.732 43.0598 324.869 42.5393C323.002 42.0086 320.991 41.534 318.827 41.1104C316.949 40.743 315.076 40.3297 313.214 39.8653C311.346 39.3907 309.652 38.7324 308.131 37.8853C306.605 37.0433 305.381 35.9155 304.457 34.4968C303.543 33.0833 303.089 31.2717 303.089 29.0672C303.089 26.3319 303.783 24.0355 305.171 22.1678C306.559 20.3052 308.458 18.9018 310.866 17.9629C313.285 17.0137 315.969 16.534 318.909 16.534C323.644 16.534 327.584 17.7587 330.728 20.2082C333.881 22.6475 335.831 26.0461 336.566 30.4144H330.34C329.656 27.6281 328.304 25.6073 326.278 24.3519C324.262 23.0864 321.807 22.4536 318.909 22.4536C316.02 22.4536 313.775 22.9945 312.173 24.0661C310.581 25.1429 309.785 26.6279 309.785 28.516C309.785 30.0419 310.32 31.2411 311.397 32.1086C312.469 32.9659 313.872 33.6191 315.602 34.0682C317.342 34.5173 319.205 34.9561 321.195 35.3746C323.139 35.742 325.094 36.1809 327.053 36.681C329.023 37.1709 330.83 37.8649 332.463 38.763C334.096 39.651 335.392 40.8553 336.361 42.376C337.341 43.9018 337.831 45.8971 337.831 48.3568C337.831 52.3576 336.366 55.5828 333.442 58.0323C330.529 60.4715 326.4 61.6861 321.052 61.6861Z"
        fill="#11110D"
      />
      <mask
        id="mask0_160_251"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={31}
        y={0}
        width={29}
        height={29}
      >
        <path
          d="M31.6595 0.881531H59.553V28.775H31.6595V0.881531Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_160_251)">
        <mask
          id="mask1_160_251"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={31}
          y={0}
          width={29}
          height={29}
        >
          <path
            d="M45.6063 0.881531C37.9057 0.881531 31.6595 7.1277 31.6595 14.8283C31.6595 22.5339 37.9057 28.775 45.6063 28.775C53.3119 28.775 59.553 22.5339 59.553 14.8283C59.553 7.1277 53.3119 0.881531 45.6063 0.881531Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_160_251)">
          <mask
            id="mask2_160_251"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={31}
            y={0}
            width={30}
            height={31}
          >
            <path
              d="M60.1195 0.0139771H31.3789V30.0609H60.1195V0.0139771Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_160_251)">
            <mask
              id="mask3_160_251"
              style={{
                maskType: "luminance",
              }}
              maskUnits="userSpaceOnUse"
              x={31}
              y={0}
              width={29}
              height={29}
            >
              <path
                d="M31.6595 0.881531H59.553V28.775H31.6595V0.881531Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_160_251)">
              <mask
                id="mask4_160_251"
                style={{
                  maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={31}
                y={0}
                width={29}
                height={29}
              >
                <path
                  d="M45.6063 0.881531C37.9057 0.881531 31.6595 7.1277 31.6595 14.8283C31.6595 22.5339 37.9057 28.775 45.6063 28.775C53.3119 28.775 59.553 22.5339 59.553 14.8283C59.553 7.1277 53.3119 0.881531 45.6063 0.881531Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask4_160_251)">
                <path
                  d="M31.6595 0.881531H59.553V28.775H31.6595V0.881531Z"
                  fill="#11110D"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <mask
        id="mask5_160_251"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={32}
        width={28}
        height={29}
      >
        <path d="M0 32.1685H27.8986V60.062H0V32.1685Z" fill="white" />
      </mask>
      <g mask="url(#mask5_160_251)">
        <mask
          id="mask6_160_251"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={32}
          width={28}
          height={29}
        >
          <path
            d="M13.9518 32.1685C6.24617 32.1685 0 38.4096 0 46.1152C0 53.8158 6.24617 60.062 13.9518 60.062C21.6524 60.062 27.8986 53.8158 27.8986 46.1152C27.8986 38.4096 21.6524 32.1685 13.9518 32.1685Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask6_160_251)">
          <mask
            id="mask7_160_251"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={-2}
            y={31}
            width={31}
            height={30}
          >
            <path
              d="M28.7661 31.3674H-1.28088V60.1079H28.7661V31.3674Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask7_160_251)">
            <mask
              id="mask8_160_251"
              style={{
                maskType: "luminance",
              }}
              maskUnits="userSpaceOnUse"
              x={0}
              y={32}
              width={28}
              height={29}
            >
              <path d="M0 32.1685H27.8986V60.062H0V32.1685Z" fill="white" />
            </mask>
            <g mask="url(#mask8_160_251)">
              <mask
                id="mask9_160_251"
                style={{
                  maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={0}
                y={32}
                width={28}
                height={29}
              >
                <path
                  d="M13.9518 32.1685C6.24617 32.1685 0 38.4096 0 46.1152C0 53.8158 6.24617 60.062 13.9518 60.062C21.6524 60.062 27.8986 53.8158 27.8986 46.1152C27.8986 38.4096 21.6524 32.1685 13.9518 32.1685Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask9_160_251)">
                <path d="M0 32.1685H27.8986V60.062H0V32.1685Z" fill="#11110D" />
              </g>
            </g>
          </g>
        </g>
      </g>
      <mask
        id="mask10_160_251"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={31}
        y={32}
        width={29}
        height={29}
      >
        <path
          d="M31.5524 32.0562H59.553V60.0619H31.5524V32.0562Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask10_160_251)">
        <mask
          id="mask11_160_251"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={31}
          y={32}
          width={29}
          height={29}
        >
          <path
            d="M37.5383 32.1685H53.6793C56.9249 32.1685 59.553 34.7966 59.553 38.0422V54.1832C59.553 57.4288 56.9249 60.062 53.6793 60.062H37.5383C34.2927 60.062 31.6595 57.4288 31.6595 54.1832V38.0422C31.6595 34.7966 34.2927 32.1685 37.5383 32.1685Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask11_160_251)">
          <mask
            id="mask12_160_251"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={31}
            y={31}
            width={30}
            height={30}
          >
            <path
              d="M60.1195 31.3674H31.3789V60.1079H60.1195V31.3674Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask12_160_251)">
            <mask
              id="mask13_160_251"
              style={{
                maskType: "luminance",
              }}
              maskUnits="userSpaceOnUse"
              x={31}
              y={32}
              width={29}
              height={29}
            >
              <path
                d="M31.5626 32.0563H59.553V60.0621H31.5626V32.0563Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask13_160_251)">
              <mask
                id="mask14_160_251"
                style={{
                  maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={31}
                y={32}
                width={29}
                height={29}
              >
                <path
                  d="M37.5384 32.1686H53.6794C56.925 32.1686 59.5531 34.7967 59.5531 38.0423V54.1833C59.5531 57.4289 56.925 60.0621 53.6794 60.0621H37.5384C34.2928 60.0621 31.6596 57.4289 31.6596 54.1833V38.0423C31.6596 34.7967 34.2928 32.1686 37.5384 32.1686Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask14_160_251)">
                <path
                  d="M31.6596 32.1686H59.5531V60.0621H31.6596V32.1686Z"
                  fill="#FF692D"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <mask
        id="mask15_160_251"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={28}
        height={29}
      >
        <path d="M0 0.881531H27.8986V28.775H0V0.881531Z" fill="white" />
      </mask>
      <g mask="url(#mask15_160_251)">
        <mask
          id="mask16_160_251"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={28}
          height={29}
        >
          <path
            d="M4.89896 0.881531H22.9996C25.7042 0.881531 27.8986 3.07586 27.8986 5.78049V23.876C27.8986 26.5807 25.7042 28.775 22.9996 28.775H4.89896C2.19433 28.775 0 26.5807 0 23.876V5.78049C0 3.07586 2.19433 0.881531 4.89896 0.881531Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask16_160_251)">
          <mask
            id="mask17_160_251"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={-2}
            y={0}
            width={31}
            height={31}
          >
            <path
              d="M28.7661 0.0139771H-1.28088V30.0609H28.7661V0.0139771Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask17_160_251)">
            <mask
              id="mask18_160_251"
              style={{
                maskType: "luminance",
              }}
              maskUnits="userSpaceOnUse"
              x={0}
              y={0}
              width={28}
              height={29}
            >
              <path d="M0 0.881531H27.8986V28.775H0V0.881531Z" fill="white" />
            </mask>
            <g mask="url(#mask18_160_251)">
              <mask
                id="mask19_160_251"
                style={{
                  maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={0}
                y={0}
                width={28}
                height={29}
              >
                <path
                  d="M4.89896 0.881531H22.9996C25.7042 0.881531 27.8986 3.07586 27.8986 5.78049V23.876C27.8986 26.5807 25.7042 28.775 22.9996 28.775H4.89896C2.19433 28.775 0 26.5807 0 23.876V5.78049C0 3.07586 2.19433 0.881531 4.89896 0.881531Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask19_160_251)">
                <path
                  d="M0 0.881531H27.8986V28.775H0V0.881531Z"
                  fill="#FF692D"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
  // <svg  viewBox="0 0 119 33" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <mask id="mask0_75_5" style={{ maskType : "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="33">
  //         <path
  //             d="M0 6C0 3.17157 0 1.75736 0.87868 0.87868C1.75736 0 3.17157 0 6 0H31.2321C32.2085 0 33 0.791497 33 1.76786V1.76786C33 19.0169 19.0169 33 1.76786 33V33C0.791496 33 0 32.2085 0 31.2321V6Z"
  //             fill="#d1f470"/>
  //       </mask>
  //       <g mask="url(#mask0_75_5)">
  //         <path
  //             d="M0 6C0 3.17157 0 1.75736 0.87868 0.87868C1.75736 0 3.17157 0 6 0H31.2321C32.2085 0 33 0.791497 33 1.76786V1.76786C33 19.0169 19.0169 33 1.76786 33V33C0.791496 33 0 32.2085 0 31.2321V6Z"
  //             fill="#d1f470"/>
  //         <path
  //             d="M11 17.5C11 14.6716 11 13.2574 11.8787 12.3787C12.7574 11.5 14.1716 11.5 17 11.5H24.25C24.6642 11.5 25 11.8358 25 12.25V12.25C25 19.5678 19.0678 25.5 11.75 25.5V25.5C11.3358 25.5 11 25.1642 11 24.75V17.5Z"
  //             fill="#191F33"/>
  //       </g>
  //       <path
  //           d="M42.2 26V25.604L50.72 11.432H42.8V8.72H55.724V9.128L47.252 23.276H55.52V26H42.2ZM63.1181 26.36C61.8221 26.36 60.6901 26.068 59.7221 25.484C58.7541 24.9 58.0021 24.096 57.4661 23.072C56.9381 22.04 56.6741 20.856 56.6741 19.52C56.6741 18.16 56.9461 16.968 57.4901 15.944C58.0341 14.92 58.7901 14.12 59.7581 13.544C60.7261 12.968 61.8461 12.68 63.1181 12.68C64.4221 12.68 65.5581 12.972 66.5261 13.556C67.4941 14.14 68.2461 14.948 68.7821 15.98C69.3181 17.004 69.5861 18.184 69.5861 19.52C69.5861 20.864 69.3141 22.052 68.7701 23.084C68.2341 24.108 67.4821 24.912 66.5141 25.496C65.5461 26.072 64.4141 26.36 63.1181 26.36ZM63.1181 23.648C64.2701 23.648 65.1261 23.264 65.6861 22.496C66.2461 21.728 66.5261 20.736 66.5261 19.52C66.5261 18.264 66.2421 17.264 65.6741 16.52C65.1061 15.768 64.2541 15.392 63.1181 15.392C62.3421 15.392 61.7021 15.568 61.1981 15.92C60.7021 16.264 60.3341 16.748 60.0941 17.372C59.8541 17.988 59.7341 18.704 59.7341 19.52C59.7341 20.776 60.0181 21.78 60.5861 22.532C61.1621 23.276 62.0061 23.648 63.1181 23.648ZM77.258 26.36C75.994 26.36 74.934 26.06 74.078 25.46C73.222 24.86 72.578 24.044 72.146 23.012C71.714 21.972 71.498 20.808 71.498 19.52C71.498 18.216 71.714 17.048 72.146 16.016C72.578 14.984 73.21 14.172 74.042 13.58C74.882 12.98 75.918 12.68 77.15 12.68C78.374 12.68 79.434 12.98 80.33 13.58C81.234 14.172 81.934 14.984 82.43 16.016C82.926 17.04 83.174 18.208 83.174 19.52C83.174 20.816 82.93 21.98 82.442 23.012C81.954 24.044 81.266 24.86 80.378 25.46C79.49 26.06 78.45 26.36 77.258 26.36ZM71.006 26V8.72H73.922V16.904H73.562V26H71.006ZM76.814 23.768C77.566 23.768 78.186 23.58 78.674 23.204C79.162 22.828 79.522 22.32 79.754 21.68C79.994 21.032 80.114 20.312 80.114 19.52C80.114 18.736 79.994 18.024 79.754 17.384C79.514 16.736 79.142 16.224 78.638 15.848C78.134 15.464 77.494 15.272 76.718 15.272C75.982 15.272 75.382 15.452 74.918 15.812C74.454 16.164 74.11 16.66 73.886 17.3C73.67 17.932 73.562 18.672 73.562 19.52C73.562 20.36 73.67 21.1 73.886 21.74C74.11 22.38 74.458 22.88 74.93 23.24C75.41 23.592 76.038 23.768 76.814 23.768ZM84.8591 26V8.36H87.7511V26H84.8591ZM90.3856 11.072V8.42H93.2776V11.072H90.3856ZM90.3856 26V13.04H93.2776V26H90.3856ZM100.676 26.36C99.0762 26.36 97.7762 26 96.7762 25.28C95.7762 24.56 95.1682 23.548 94.9522 22.244L97.9042 21.788C98.0562 22.428 98.3922 22.932 98.9122 23.3C99.4322 23.668 100.088 23.852 100.88 23.852C101.576 23.852 102.112 23.716 102.488 23.444C102.872 23.164 103.064 22.784 103.064 22.304C103.064 22.008 102.992 21.772 102.848 21.596C102.712 21.412 102.408 21.236 101.936 21.068C101.464 20.9 100.74 20.688 99.7642 20.432C98.6762 20.144 97.8122 19.836 97.1722 19.508C96.5322 19.172 96.0722 18.776 95.7922 18.32C95.5122 17.864 95.3722 17.312 95.3722 16.664C95.3722 15.856 95.5842 15.152 96.0082 14.552C96.4322 13.952 97.0242 13.492 97.7842 13.172C98.5442 12.844 99.4402 12.68 100.472 12.68C101.48 12.68 102.372 12.836 103.148 13.148C103.932 13.46 104.564 13.904 105.044 14.48C105.524 15.056 105.82 15.732 105.932 16.508L102.98 17.036C102.908 16.484 102.656 16.048 102.224 15.728C101.8 15.408 101.232 15.228 100.52 15.188C99.8402 15.148 99.2922 15.252 98.8762 15.5C98.4602 15.74 98.2522 16.08 98.2522 16.52C98.2522 16.768 98.3362 16.98 98.5042 17.156C98.6722 17.332 99.0082 17.508 99.5122 17.684C100.024 17.86 100.784 18.076 101.792 18.332C102.824 18.596 103.648 18.9 104.264 19.244C104.888 19.58 105.336 19.984 105.608 20.456C105.888 20.928 106.028 21.5 106.028 22.172C106.028 23.476 105.552 24.5 104.6 25.244C103.656 25.988 102.348 26.36 100.676 26.36ZM112.461 26.36C110.861 26.36 109.561 26 108.561 25.28C107.561 24.56 106.953 23.548 106.737 22.244L109.689 21.788C109.841 22.428 110.177 22.932 110.697 23.3C111.217 23.668 111.873 23.852 112.665 23.852C113.361 23.852 113.897 23.716 114.273 23.444C114.657 23.164 114.849 22.784 114.849 22.304C114.849 22.008 114.777 21.772 114.633 21.596C114.497 21.412 114.193 21.236 113.721 21.068C113.249 20.9 112.525 20.688 111.549 20.432C110.461 20.144 109.597 19.836 108.957 19.508C108.317 19.172 107.857 18.776 107.577 18.32C107.297 17.864 107.157 17.312 107.157 16.664C107.157 15.856 107.369 15.152 107.793 14.552C108.217 13.952 108.809 13.492 109.569 13.172C110.329 12.844 111.225 12.68 112.257 12.68C113.265 12.68 114.157 12.836 114.933 13.148C115.717 13.46 116.349 13.904 116.829 14.48C117.309 15.056 117.605 15.732 117.717 16.508L114.765 17.036C114.693 16.484 114.441 16.048 114.009 15.728C113.585 15.408 113.017 15.228 112.305 15.188C111.625 15.148 111.077 15.252 110.661 15.5C110.245 15.74 110.037 16.08 110.037 16.52C110.037 16.768 110.121 16.98 110.289 17.156C110.457 17.332 110.793 17.508 111.297 17.684C111.809 17.86 112.569 18.076 113.577 18.332C114.609 18.596 115.433 18.9 116.049 19.244C116.673 19.58 117.121 19.984 117.393 20.456C117.673 20.928 117.813 21.5 117.813 22.172C117.813 23.476 117.337 24.5 116.385 25.244C115.441 25.988 114.133 26.36 112.461 26.36Z"
  //           fill="currentColor"/>
  //     </svg>
  // );
};

export const ZoblissOnlyBoxLogo = (props) => {
  // Unique mask ids: a hidden instance elsewhere on the page would otherwise own the shared ids.
  const uid = useId().replace(/:/g, "");
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id={`${uid}-mask0`}
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={31}
        y={0}
        width={29}
        height={28}
      >
        <path d="M31.6595 0H59.553V27.8934H31.6595V0Z" fill="white" />
      </mask>
      <g mask={`url(#${uid}-mask0)`}>
        <mask
          id={`${uid}-mask1`}
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={31}
          y={0}
          width={29}
          height={28}
        >
          <path
            d="M45.6063 0C37.9057 0 31.6595 6.24617 31.6595 13.9467C31.6595 21.6524 37.9057 27.8934 45.6063 27.8934C53.3119 27.8934 59.553 21.6524 59.553 13.9467C59.553 6.24617 53.3119 0 45.6063 0Z"
            fill="white"
          />
        </mask>
        <g mask={`url(#${uid}-mask1)`}>
          <mask
            id={`${uid}-mask2`}
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={31}
            y={-1}
            width={30}
            height={31}
          >
            <path
              d="M60.1195 -0.867554H31.3789V29.1794H60.1195V-0.867554Z"
              fill="white"
            />
          </mask>
          <g mask={`url(#${uid}-mask2)`}>
            <mask
              id={`${uid}-mask3`}
              style={{
                maskType: "luminance",
              }}
              maskUnits="userSpaceOnUse"
              x={31}
              y={0}
              width={29}
              height={28}
            >
              <path d="M31.6595 0H59.553V27.8934H31.6595V0Z" fill="white" />
            </mask>
            <g mask={`url(#${uid}-mask3)`}>
              <mask
                id={`${uid}-mask4`}
                style={{
                  maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={31}
                y={0}
                width={29}
                height={28}
              >
                <path
                  d="M45.6063 0C37.9057 0 31.6595 6.24617 31.6595 13.9467C31.6595 21.6524 37.9057 27.8934 45.6063 27.8934C53.3119 27.8934 59.553 21.6524 59.553 13.9467C59.553 6.24617 53.3119 0 45.6063 0Z"
                  fill="white"
                />
              </mask>
              <g mask={`url(#${uid}-mask4)`}>
                <path d="M31.6595 0H59.553V27.8934H31.6595V0Z" fill="#11110D" />
              </g>
            </g>
          </g>
        </g>
      </g>
      <mask
        id={`${uid}-mask5`}
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={31}
        width={28}
        height={29}
      >
        <path d="M0 31.287H27.8986V59.1804H0V31.287Z" fill="white" />
      </mask>
      <g mask={`url(#${uid}-mask5)`}>
        <mask
          id={`${uid}-mask6`}
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={31}
          width={28}
          height={29}
        >
          <path
            d="M13.9518 31.287C6.24617 31.287 0 37.5281 0 45.2337C0 52.9343 6.24617 59.1804 13.9518 59.1804C21.6524 59.1804 27.8986 52.9343 27.8986 45.2337C27.8986 37.5281 21.6524 31.287 13.9518 31.287Z"
            fill="white"
          />
        </mask>
        <g mask={`url(#${uid}-mask6)`}>
          <mask
            id={`${uid}-mask7`}
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={-2}
            y={30}
            width={31}
            height={30}
          >
            <path
              d="M28.7661 30.4858H-1.28088V59.2264H28.7661V30.4858Z"
              fill="white"
            />
          </mask>
          <g mask={`url(#${uid}-mask7)`}>
            <mask
              id={`${uid}-mask8`}
              style={{
                maskType: "luminance",
              }}
              maskUnits="userSpaceOnUse"
              x={0}
              y={31}
              width={28}
              height={29}
            >
              <path d="M0 31.287H27.8986V59.1804H0V31.287Z" fill="white" />
            </mask>
            <g mask={`url(#${uid}-mask8)`}>
              <mask
                id={`${uid}-mask9`}
                style={{
                  maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={0}
                y={31}
                width={28}
                height={29}
              >
                <path
                  d="M13.9518 31.287C6.24617 31.287 0 37.5281 0 45.2337C0 52.9343 6.24617 59.1804 13.9518 59.1804C21.6524 59.1804 27.8986 52.9343 27.8986 45.2337C27.8986 37.5281 21.6524 31.287 13.9518 31.287Z"
                  fill="white"
                />
              </mask>
              <g mask={`url(#${uid}-mask9)`}>
                <path d="M0 31.287H27.8986V59.1804H0V31.287Z" fill="#11110D" />
              </g>
            </g>
          </g>
        </g>
      </g>
      <mask
        id={`${uid}-mask10`}
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={31}
        y={31}
        width={29}
        height={29}
      >
        <path
          d="M31.5524 31.1748H59.553V59.1805H31.5524V31.1748Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#${uid}-mask10)`}>
        <mask
          id={`${uid}-mask11`}
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={31}
          y={31}
          width={29}
          height={29}
        >
          <path
            d="M37.5383 31.2871H53.6793C56.9249 31.2871 59.553 33.9152 59.553 37.1608V53.3018C59.553 56.5474 56.9249 59.1806 53.6793 59.1806H37.5383C34.2927 59.1806 31.6595 56.5474 31.6595 53.3018V37.1608C31.6595 33.9152 34.2927 31.2871 37.5383 31.2871Z"
            fill="white"
          />
        </mask>
        <g mask={`url(#${uid}-mask11)`}>
          <mask
            id={`${uid}-mask12`}
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={31}
            y={30}
            width={30}
            height={30}
          >
            <path
              d="M60.1195 30.486H31.3789V59.2265H60.1195V30.486Z"
              fill="white"
            />
          </mask>
          <g mask={`url(#${uid}-mask12)`}>
            <mask
              id={`${uid}-mask13`}
              style={{
                maskType: "luminance",
              }}
              maskUnits="userSpaceOnUse"
              x={31}
              y={31}
              width={29}
              height={29}
            >
              <path
                d="M31.5626 31.1749H59.553V59.1806H31.5626V31.1749Z"
                fill="white"
              />
            </mask>
            <g mask={`url(#${uid}-mask13)`}>
              <mask
                id={`${uid}-mask14`}
                style={{
                  maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={31}
                y={31}
                width={29}
                height={29}
              >
                <path
                  d="M37.5383 31.2872H53.6793C56.9249 31.2872 59.553 33.9153 59.553 37.1609V53.3019C59.553 56.5475 56.9249 59.1807 53.6793 59.1807H37.5383C34.2927 59.1807 31.6595 56.5475 31.6595 53.3019V37.1609C31.6595 33.9153 34.2927 31.2872 37.5383 31.2872Z"
                  fill="white"
                />
              </mask>
              <g mask={`url(#${uid}-mask14)`}>
                <path
                  d="M31.6595 31.2872H59.553V59.1807H31.6595V31.2872Z"
                  fill="#FF692D"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <mask
        id={`${uid}-mask15`}
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={28}
        height={28}
      >
        <path d="M0 0H27.8986V27.8934H0V0Z" fill="white" />
      </mask>
      <g mask={`url(#${uid}-mask15)`}>
        <mask
          id={`${uid}-mask16`}
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={28}
          height={28}
        >
          <path
            d="M4.89896 0H22.9996C25.7042 0 27.8986 2.19433 27.8986 4.89896V22.9945C27.8986 25.6991 25.7042 27.8934 22.9996 27.8934H4.89896C2.19433 27.8934 0 25.6991 0 22.9945V4.89896C0 2.19433 2.19433 0 4.89896 0Z"
            fill="white"
          />
        </mask>
        <g mask={`url(#${uid}-mask16)`}>
          <mask
            id={`${uid}-mask17`}
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={-2}
            y={-1}
            width={31}
            height={31}
          >
            <path
              d="M28.7661 -0.867554H-1.28088V29.1794H28.7661V-0.867554Z"
              fill="white"
            />
          </mask>
          <g mask={`url(#${uid}-mask17)`}>
            <mask
              id={`${uid}-mask18`}
              style={{
                maskType: "luminance",
              }}
              maskUnits="userSpaceOnUse"
              x={0}
              y={0}
              width={28}
              height={28}
            >
              <path d="M0 0H27.8986V27.8934H0V0Z" fill="white" />
            </mask>
            <g mask={`url(#${uid}-mask18)`}>
              <mask
                id={`${uid}-mask19`}
                style={{
                  maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={0}
                y={0}
                width={28}
                height={28}
              >
                <path
                  d="M4.89896 0H22.9996C25.7042 0 27.8986 2.19433 27.8986 4.89896V22.9945C27.8986 25.6991 25.7042 27.8934 22.9996 27.8934H4.89896C2.19433 27.8934 0 25.6991 0 22.9945V4.89896C0 2.19433 2.19433 0 4.89896 0Z"
                  fill="white"
                />
              </mask>
              <g mask={`url(#${uid}-mask19)`}>
                <path d="M0 0H27.8986V27.8934H0V0Z" fill="#FF692D" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ApplicationFormIcon = (props) => {
  return (
    <svg
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      name="ApplicationFormIcon"
      fill="none"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M8 13H16"
        vectorEffect="non-scaling-stroke"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M8 17H16"
        vectorEffect="non-scaling-stroke"
      />
      <path
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M6 3H15.172C15.702 3 16.211 3.211 16.586 3.586L19.414 6.414C19.789 6.789 20 7.298 20 7.828V19C20 20.105 19.105 21 18 21H6C4.895 21 4 20.105 4 19V5C4 3.895 4.895 3 6 3Z"
        clipRule="evenodd"
        vectorEffect="non-scaling-stroke"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M20 8H16C15.448 8 15 7.552 15 7V3"
        vectorEffect="non-scaling-stroke"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M8 9H11"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};

export const PlanStandardIcon = (props) => {
  return (
    <svg
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      name="PlanStandardIcon"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.0705 4.99703C12.9925 4.45028 12.5523 4 12 4C11.4477 4 11.0075 4.45028 10.9295 4.99703C10.492 8.06511 8.06512 10.492 4.99703 10.9295C4.45028 11.0075 4 11.4477 4 12C4 12.5523 4.45028 12.9925 4.99703 13.0705C8.06512 13.508 10.492 15.9349 10.9295 19.003C11.0075 19.5497 11.4477 20 12 20C12.5523 20 12.9925 19.5497 13.0705 19.003C13.508 15.9349 15.9349 13.508 19.003 13.0705C19.5497 12.9925 20 12.5523 20 12C20 11.4477 19.5497 11.0075 19.003 10.9295C15.9349 10.492 13.508 8.06512 13.0705 4.99703Z"
        clipRule="evenodd"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};

export const PlanAdvancedIcon = (props) => {
  return (
    <svg
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      name="PlanAdvancedIcon"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.66904 12.6231C7.62031 12.2814 7.34518 12 7 12C6.65482 12 6.37969 12.2814 6.33096 12.6231C6.05751 14.5407 4.5407 16.0575 2.62314 16.331C2.28142 16.3797 2 16.6548 2 17C2 17.3452 2.28142 17.6203 2.62314 17.669C4.5407 17.9425 6.05751 19.4593 6.33096 21.3769C6.37969 21.7186 6.65482 22 7 22C7.34518 22 7.62031 21.7186 7.66904 21.3769C7.94249 19.4593 9.4593 17.9425 11.3769 17.669C11.7186 17.6203 12 17.3452 12 17C12 16.6548 11.7186 16.3797 11.3769 16.331C9.4593 16.0575 7.94249 14.5407 7.66904 12.6231Z"
        clipRule="evenodd"
        vectorEffect="non-scaling-stroke"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.8028 2.74777C16.7444 2.33771 16.4142 2 16 2C15.5858 2 15.2556 2.33771 15.1972 2.74777C14.869 5.04884 13.0488 6.86902 10.7478 7.19715C10.3377 7.25563 10 7.58579 10 8C10 8.41421 10.3377 8.74437 10.7478 8.80285C13.0488 9.13098 14.869 10.9512 15.1972 13.2522C15.2556 13.6623 15.5858 14 16 14C16.4142 14 16.7444 13.6623 16.8028 13.2522C17.131 10.9512 18.9512 9.13098 21.2522 8.80285C21.6623 8.74437 22 8.41421 22 8C22 7.58579 21.6623 7.25563 21.2522 7.19715C18.9512 6.86902 17.131 5.04884 16.8028 2.74777Z"
        clipRule="evenodd"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};

export const EnterIcon = (props) => {
  return (
    <svg
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      name="EnterIcon"
      fill="none"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.7}
        d="M6.13367 14.8835H14.8C16.4568 14.8835 17.7999 13.5404 17.7999 11.8835V6.13379"
        vectorEffect="non-scaling-stroke"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.7}
        d="M17.8 6.13379H13.8"
        vectorEffect="non-scaling-stroke"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.7}
        d="M9.05024 17.8009L6.13367 14.8843L9.05024 11.9678"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};
